module.exports = __webpack_public_path__ + "img/ba1.f53803c2.jpg";